import React, { Fragment, useMemo } from 'react';
import {
    Button,
} from 'reactstrap';
import { FaExternalLinkAlt } from "react-icons/fa";

const ViewLogs = ({ row, onOpenLogs, renderTrigger }) => {

    const viewTriggerNode = useMemo(() => {
        if (typeof renderTrigger === "function") {
            return renderTrigger({ onClick: () => onOpenLogs(row) });
        }

        return (
            <Button
                color="primary"
                size="sm"
                onClick={() => onOpenLogs(row)}
            >
                <FaExternalLinkAlt />
                
            </Button>
        );
    }, [renderTrigger, row, onOpenLogs]);

    return <>{viewTriggerNode}</>;
};

export default ViewLogs;
